import { useContext } from 'react';
import { ClubContext, ClubContextResult } from 'src/context/ClubContext';

export function useClub(): ClubContextResult {
  const ctx = useContext(ClubContext);
  if (!ctx) throw Error(`Trying to use useClub outside its provider`);
  return ctx;
}
